<div class="dialog-container">
  <img [src]="images.STATUS" class="wd-100" alt="status" />
  <img (click)="cancelClicked()" [src]="images.CLOSE_ICON_GRAY" class="close-icon-cls" alt="close" />
    <div class="flex-center flex_column p-b-13">
    <div class="fs-22 fw-600 m-t-10 black-clr">{{paymentStatusText}}</div>
    <div class="flex-center flex_column m-t-5 p-l-10 p-r-10 wd-100">
      <div class="flex flex_row wd-100 align_center"><div class="wd-30 mleft-vw">{{'SHARED.AMOUNT' | fallbackTranslate}}:</div> <div class="wd-50 fs-16 fw-500 black-clr">{{currency}} {{amount.toFixed(2)}}</div></div>
      <div class="flex flex_row wd-100 align_center"><div class="wd-30 mleft-vw">{{'SHARED.PAYMENT_MODE' | fallbackTranslate}}:</div> <div class="wd-50 fs-16 fw-500 black-clr">{{paymentMethod}}</div></div>
    </div>  
    </div>
</div>